export default "__VITE_ASSET__DO2TWP83__"